import { StyledSlider } from '@/pages/AdvancedEditor/components/panels/common/StyledSlider';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { getAvatarElementFromPage } from '@/pages/AdvancedEditor/utils';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { ControlNumberInput } from '../../../common/ControlNumberInput';

const MAX_NUM_PIXELS_IN_OFFSET = 100;

const Container = styled.div`
    display: flex;
    gap: 16px;
    justify-content: center;
    align-items: center;
    width: 220px;
`;

interface Props {
    shadowOffsetField: 'shadowOffsetX' | 'shadowOffsetY';
}

export const ShadowOffsetControl = observer(({ shadowOffsetField }: Props) => {
    const { store } = useAdvancedEditorContext();
    const avatarElement = getAvatarElementFromPage(store.activePage);

    if (!avatarElement) return null;

    const handleChange = (value: number) => {
        avatarElement.set({ [shadowOffsetField]: value });
    };

    return (
        <Container>
            <StyledSlider
                value={avatarElement[shadowOffsetField]}
                onChange={(_e, value) => handleChange(value as number)}
                step={1}
                min={-MAX_NUM_PIXELS_IN_OFFSET}
                max={MAX_NUM_PIXELS_IN_OFFSET}
            />
            <ControlNumberInput
                value={avatarElement[shadowOffsetField]}
                onChange={handleChange}
                min={-MAX_NUM_PIXELS_IN_OFFSET}
                max={MAX_NUM_PIXELS_IN_OFFSET}
                suffix="px"
            />
        </Container>
    );
});
